import { FullLayout } from '@pages/FullLayout'
import { Button } from '@components/ui/button'
import { useNavigate } from 'react-router-dom'
import { useTheme } from '@components/ThemeProvider'

const NotFound = () => {
  const navigate = useNavigate()
  const { resolvedTheme } = useTheme()

  return (
    <FullLayout.ContentCenter>
      <FullLayout.Logo />
      <div className="flex flex-col items-center justify-center max-w-lg w-full">
        <Choose>
          <When condition={resolvedTheme === 'dark'}>
            <img src="/searching-dark.svg" alt="Page not found" className="w-[120px] self-center mb-5" />
          </When>
          <Otherwise>
            <img src="/searching.svg" alt="Page not found" className="w-[120px] self-center mb-5" />
          </Otherwise>
        </Choose>
        <h1 className="text-3xl font-bold mb-2 text-foreground">Page not found</h1>
        <p className="text-lg text-muted-foreground mb-6 text-center">Sorry, we couldn't find the page you're looking for. It might have been moved or deleted.</p>
        <Button
          onClick={() => navigate('/')}
          className="w-full max-w-xs"
        >
          Go to Home
        </Button>
      </div>
    </FullLayout.ContentCenter>
  )
}

export default NotFound
